import React, { ChangeEvent, useState } from 'react'
import { Checkbox, FormControlLabel } from '@mui/material'
import {
  useProductSpecificPlatformFeatureUpdate,
  useRefreshProductPlatformFeatures,
} from 'shared/api/productPlatformFeatures'

interface ProductPlatformFeatureItemProps {
  productId: number
  feature: any
  isChecked: boolean
  isEditable: boolean
}

const kebabToTitle = (kebabStr: string) => {
  return kebabStr
    .split('-')
    .map((word) => {
      return word.toLowerCase() === 'ai'
        ? 'AI'
        : word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
}

export function ProductPlatformFeatureItem({
  productId,
  feature,
  isChecked,
  isEditable,
}: ProductPlatformFeatureItemProps) {
  const setProductSpecificPlatformFeature =
    useProductSpecificPlatformFeatureUpdate(productId)
  const refreshProductPlatformFeatures = useRefreshProductPlatformFeatures()
  const [isCheckedState, setIsCheckedState] = useState(isChecked)

  const onChangeChecked = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked
    const platformFeatureId = e.target.value
    setProductSpecificPlatformFeature(Number(platformFeatureId), isChecked)
    refreshProductPlatformFeatures(productId)
    setIsCheckedState(isChecked)
  }

  return (
    <FormControlLabel
      control={
        <Checkbox
          disabled={!isEditable}
          value={feature.id}
          checked={isCheckedState}
          onChange={onChangeChecked}
          name={feature.name}
        />
      }
      label={kebabToTitle(feature.name)}
    />
  )
}
